/** Toast 显示时长（毫秒），各场景统一在此调整 */
export const TOAST_DURATION = {
  /** 全局 inject showToast（App.vue） */
  global: 3500,
  /** 登录、首页轻提示、技师列表等 */
  brief: 3500,
  /** 弹窗内 toast（改密、资料、编辑技师等） */
  modal: 3500,
  /** 资料库弹窗（新建/编辑/删除等） */
  long: 3500,
  /** 护理订单详情、排程成功 */
  standard: 3500,
  /** 护理新建订单、排程 warning */
  warning: 3500,
} as const
